export default __webpack_public_path__ + "static/moon_bunnies_f-2b4a58028d843d59744760897d53ddc7.jpg";